<template>
  <BaseCard max-width="600">
    <v-form ref="form">
      <BaseInput
        :label="t['setting-setting_company'].all.tracking_period"
        v-model="tracking_period"
        :viewValue="tracking_period + ' ' + t['common'].measure['minutes']"
        input-type="Number"
        v-bind="presetBaseInput"
      >
        <template slot="append-outer">
          {{ t.common.measure.minutes }}
        </template>
      </BaseInput>
    </v-form>
    <div class="fixedBtn">
      <BaseTooltip v-if="edit" :tooltip="t.common['buttons']['sohranit']">
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="onSave"
          round
          icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip v-else :tooltip="t.common['buttons']['redaktirovat']">
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit" />
      </BaseTooltip>
    </div>
  </BaseCard>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'settingCompanyGeoPosition',
  data: () => ({
    tracking_period: 0,
  }),
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    t() {
      return this.localStorage.translations.pages
    },
    n() {
      return this.t.common.notifications
    },
    edit() {
      return this.$route.name === 'SettingCompanyGeoPositionEdit'
    },
    presetBaseInput() {
      return {
        view: !this.edit,
        rules: ['required'],
      }
    },
  },
  watch: {
    tracking_period() {
      if (this.edit) this.onCheckChange({ overwrite: false })
    },
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    companiesConfig() {
      console.log(this.companiesConfig)
      this.tracking_period = this.companiesConfig.tracking_period || 0
      if (this.edit) this.onCheckChange({ overwrite: true })
    },
  },
  created() {
    this.onLoadData()
  },
  methods: {
    ...mapActions(['onCompaniesConfig']),
    ...mapActions('commonConfig', ['onCommonConfigSettingsUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { GeoPosition: { tracking_period: Number(this.tracking_period) } },
        overwrite,
      })
    },
    async onLoadData() {
      await this.onCompaniesConfig()
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['oshibka'], IsError: false },
            { root: true },
          )
        })
    },
    onEdit() {
      this.$router.push({
        name: this.edit ? 'SettingCompanyGeoPosition' : 'SettingCompanyGeoPositionEdit',
      })
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        let temp = { tracking_period: this.tracking_period }
        await this.onCommonConfigSettingsUpdate({ name: 'report', data: temp })
          .then(() => {
            this.onCheckChange({ overwrite: true })
            this.$store.dispatch(
              'popup/onMessage',
              { message: this.n['izmeneniya-uspeshno-sohraneny'], IsError: false },
              { root: true },
            )
            setTimeout(() => {
              this.onEdit()
            }, 300)
          })
          .catch(() => {
            this.$store.dispatch(
              'popup/onMessage',
              { message: this.n['oshibka'], IsError: false },
              { root: true },
            )
          })
      }
    },
  },
}
</script>